import store from '@/store'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

const hide = () => !store.getters['pos/isModuleEnabled'] || !store.getters['subscription/isAddonPurchased']('ok_pos')

export default [
  {
    title: 'pos.pos',
    svgIcon: 'icon-pos',
    hide,
    children: [
      {
        title: 'pos.preview',
        route: 'admin:pos:preview',
        svgIcon: 'icon-pos-preview',
        permission: SUBUSER_PERMISSION_SLUGS.POS_PREVIEW_VIEW,
        hide,
      },
      {
        title: 'pos.register-terminals',
        route: 'admin:pos:terminals',
        svgIcon: 'icon-pos-register-terminal',
        permission: SUBUSER_PERMISSION_SLUGS.POS_TERMINALS_VIEW,
        hide,
      },
      {
        title: 'pos.cashier-sessions',
        route: 'admin:pos:sessions',
        svgIcon: 'icon-cashier',
        permission: SUBUSER_PERMISSION_SLUGS.POS_SESSIONS_VIEW,
        hide,
      },
      {
        title: 'pos.pos-settings',
        route: 'admin:pos:settings',
        svgIcon: 'icon-settings',
        permission: SUBUSER_PERMISSION_SLUGS.POS_SETTINGS_VIEW,
        hide,
      },
    ],
  },

]
